<template>
  <div>
    <p>
      <b>Tên BN:</b>
      {{ benhNhan.name ? benhNhan.name : $t('unknown') }}
    </p>
    <p>
      <b>Năm sinh:</b>
      {{ benhNhan.dob ? benhNhan.dob : $t('unknown') }}
    </p>
    <p>
      <b>Giới tính:</b>
      {{ benhNhan.gender === 'male' ? 'Nam' : benhNhan.gender === 'female' ? 'Nữ' : 'Không rõ' }}
    </p>
    <p v-if="benhNhan.seniorDoctorUser">
      <b v-b-tooltip="'Bác sỹ trưởng nhóm/Bác sỹ phó nhóm'">BSTN/BSPN: </b>
      <button-link-user :user="benhNhan.seniorDoctorUser" />
    </p>
    <p v-if="benhNhan.emergencyDoctorUser">
      <b>Bác sỹ cấp cứu: </b>
      <button-link-user :user="benhNhan.emergencyDoctorUser" />
    </p>
    <p v-if="benhNhan.stopFollowTime">
      <span class="badge badge-secondary">Đã ngừng theo dõi</span>
    </p>
  </div>
</template>

<script>
import ButtonLinkUser from '../../../components/ButtonLinkUser';

export default {
  components: {
    ButtonLinkUser,
  },
  props: {
    benhNhan: {
      type: Object,
      required: true,
      validator: value => !!value._id,
    },
  },
};
</script>
